<script>
/**
 * Tarjeta de indicador: título, valor, icono y, opcionalmente, la variación
 * contra el periodo anterior y una nota al pie.
 */
export default {
  props: {
    title: { type: String, default: "" },
    value: { type: [String, Number], default: "" },
    icon: { type: String, default: "" },
    variant: { type: String, default: "primary" },
    /** Variación porcentual contra el periodo anterior. `null` la oculta. */
    variacion: { type: Number, default: null },
    /** Texto secundario bajo el valor (por ejemplo "32% de conversión"). */
    hint: { type: String, default: "" },
    /** Cuando es true, una variación negativa se pinta en verde (ej. bajas). */
    invertirColor: { type: Boolean, default: false },
  },
  computed: {
    variacionClase() {
      if (this.variacion === null || this.variacion === 0) return "text-muted";
      const positiva = this.variacion > 0;
      const buena = this.invertirColor ? !positiva : positiva;
      return buena ? "text-success" : "text-danger";
    },
    variacionIcono() {
      if (this.variacion === null || this.variacion === 0) return "mdi mdi-minus";
      return this.variacion > 0 ? "mdi mdi-arrow-up" : "mdi mdi-arrow-down";
    },
  },
};
</script>

<template>
  <div class="card stat-card">
    <div class="card-body">
      <div class="d-flex align-items-center">
        <div class="flex-grow-1">
          <p class="text-muted font-weight-medium mb-1">{{ title }}</p>
          <h3 class="mb-0 font-weight-bold">{{ value }}</h3>
          <p v-if="hint" class="text-muted small mb-0 mt-1">{{ hint }}</p>
          <p v-if="variacion !== null" class="small mb-0 mt-1" :class="variacionClase">
            <i :class="variacionIcono"></i>
            {{ Math.abs(variacion) }}% vs. periodo anterior
          </p>
        </div>
        <div class="stat-icon rounded-circle ml-3" :class="`bg-${variant}`">
          <i :class="`${icon} text-white font-size-24`"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.stat-card {
  height: calc(100% - 24px);
}

.stat-icon {
  width: 50px;
  height: 50px;
  min-width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
